import React from 'react';
import ReportPage from '../ReportChart/ReportPage';
import { getDefectsByDepartment } from "services/analytics";
import useChartColors from '../ReportChart/hooks/useChartColors';

const DefectsDepartmentReport = () => {
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));
  const { getAllColors } = useChartColors();

  const chartConfig = {
    id: 'defects-by-department',
    title: `${customCaptions?.defectPlural} by Department`,
    fetchData: async (params) => {
      return await getDefectsByDepartment(params);
    },
    allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
    defaultChartType: 'tree-map',
    axisConfig: {
      categoryAxis: { dataKey: 'label' },
      valueAxes: [{ 
        label: 'Count' 
      }]
    },
    series: [
      { 
        label: 'Count', 
        key: 'count', 
        showLegend: false,
        colors: getAllColors()
      }
    ],
    transformData: (response) => {
      return response?.data?.data;
    },
    filters: {
      timeframe: {
        allowCustomRange: true,
        defaultRange: 'show-all',
      },
      model: true,
      riskRatings: true
    },
    viewData: (dataPoint, params, config) => {
      return dataPoint?.isDrilledDown === false ? `/app/defects?department=all` : `/app/defects`;
    },
    itemNavigation: true,
    drilldown: {
      defaultChartType: 'tree-map',
      allowedChartTypes: ['tree-map', 'pie', 'vertical-bar'],
      axisConfig: {
        categoryAxis: { dataKey: 'label' },
        valueAxes: [{ 
          label: 'Count' 
        }]
      },
      series: [
        { 
          label: 'Count', 
          key: 'count', 
          showLegend: false,
          colors: getAllColors()
        }
      ],
      currentDrilldownLabel: `${customCaptions?.asset || 'Asset'}`,
      getParams: (dataPoint) => {
        return {
          siteDepartmentId: dataPoint.id,
          siteDepartmentIds: [dataPoint.id],
          department: {
            id: dataPoint.id,
            name: dataPoint.name || "Show All"
          }
        };
      }
    }
  };

  return (
    <ReportPage 
      title={`${customCaptions?.defectPlural} by Department`}
      chartConfig={chartConfig}
    />
  );
};

export default DefectsDepartmentReport; 
